/* global Phaser */

import WebFont from 'webfontloader';
import * as setup from '@/setup';

export default class SplashScreen extends Phaser.Scene {
	/**
	 *  Takes care of loading the main game assets, including textures, tile
	 *  maps, sound effects and other binary files, while displaying a busy
	 *  splash screen.
	 *
	 *  @extends Phaser.Scene
	 */
	constructor() {
		super({
			key: 'SplashScreen',

			//  Splash screen and progress bar textures.
			// lo splash screen e la progress bar sono caricati direttamente nella scene.
			// per queste due immagini non c'è nessun loader, quindi devono essere piccole
			// e questo èp l'unico caso in cui caricare immaggini dentro la scena
			pack: {
				files: [
					{
						key: 'logo',
						type: 'image'
					},
					{
						key: 'progress-bar',
						type: 'image'
					}
				]
			}
		});
	}

	init() {
		// set global Object to this class
		this.fontsReady = false;
		this.ready = false;
		this.fontsLoaded = this.fontsLoaded.bind(this);
		this.updateCounter = 0;
		this.assetsLoaded = false;
		this.loadError = null;
	}
	/**
	 *  Show the splash screen and prepare to load game assets.
	 *
	 *  @protected
	 */
	preload() {
		//  Display cover and progress bar textures.
		this.showCover();
		this.showProgressBar();

		// Gestisci errori di caricamento asset
		this.load.on('filecomplete', () => {
			// Asset caricato con successo
		});

		this.load.on('loaderror', (file) => {
			console.error('Errore caricamento asset:', file.key);
			this.loadError = `Errore nel caricamento dell'asset: ${file.key}`;
		});

		// Gestisci completamento caricamento asset
		this.load.once('complete', () => {
			this.assetsLoaded = true;
		});

		// Scarico i google font
		WebFont.load({
			google: {
				families: ['Luckiest Guy', 'Titillium Web']
			},
			active: this.fontsLoaded,
			inactive: () => {
				console.error('Errore caricamento font');
				this.loadError = 'Errore nel caricamento dei font';
			}
		});

		//  HINT: Declare all game assets to be loaded here.
		this.load.image('logo');
		this.load.image('background');
		this.load.image('letter-gray-light');
		this.load.image('clock');
		this.load.image('score');
		this.load.image('score-icon');
		this.load.image('power');
		this.load.image('power-icon');
		this.load.image('superpower-menu');
		this.load.image('help');
		this.load.image('game-over-background-win');
		this.load.image('game-over-background-lost');
		this.load.image('green-button');
		this.load.image('gray-button');
		this.load.image('blue-button');
		this.load.image('blue-box');
		this.load.image('orange-box');
		this.load.image('play');
		this.load.image('play1');
		this.load.image('menu');
    this.load.image('back-icon');
    this.load.image('edit-icon');
    this.load.image('on1');
    this.load.image('on2');
    this.load.image('off1');
    this.load.image('off2');

    // Audio files
    this.load.audio('button-click', 'audio/button-click.mp3');
    this.load.audio('game-win', 'audio/game-win.mp3');
    this.load.audio('game-lose', 'audio/game-lose.mp3');
    this.load.audio('letter-place', 'audio/letter-place.mp3');
    this.load.audio('error', 'audio/error.mp3');
    this.load.audio('power-use', 'audio/power-use.mp3');
    this.load.audio('skill-gain', 'audio/skill-gain.mp3');
  }

	fontsLoaded() {
		console.log('fonts loaded');
		this.fontsReady = true;
	}

	/**
	 *  Set up animations, plugins etc. that depend on the game assets we just
	 *  loaded.
	 *
	 *  @protected
	 */
	update() {
		this.updateCounter++;

		// Controlla se ci sono errori di caricamento
		if (this.loadError) {
			// Mostra box di errore semplice (NON ErrorScene, perché gli asset non sono caricati)
			if (!this.errorBoxShown) {
				this.showErrorBox(this.loadError);
				this.errorBoxShown = true;
			}
			return;
		}

		// Se il loader non ha file in coda (asset già in cache), considera gli asset come caricati
		if (!this.assetsLoaded && this.load.totalToLoad === 0) {
			this.assetsLoaded = true;
		}

		// Se asset e font sono caricati, avvia Boot
		if (this.fontsReady && this.assetsLoaded) {
			//@TODO localstorage far partire le istruzioni solo la prima volta
			//if (this.fontsReady) this.scene.start('HowtoPlay');
			this.scene.start('Boot');
		}
	}

	/**
	 * Mostra un box di errore semplice quando c'è un errore nel caricamento asset/font
	 * NON usa ErrorScene perché gli asset non sono ancora caricati
	 */
	showErrorBox(message) {
		const width = this.sys.game.config.width;
		const height = this.sys.game.config.height;
		const centerX = width / 2;
		const centerY = height / 2;

		// Background semi-trasparente
		const bg = this.add.rectangle(centerX, centerY, width * 0.8, height * 0.4, 0x000000, 0.8);
		bg.setStrokeStyle(3, 0xff0000);

		// Testo errore
		const errorText = this.add.text(centerX, centerY - 30, 'ERRORE', {
			fontSize: 48,
			fontFamily: 'Arial',
			fill: '#ff0000',
			align: 'center'
		}).setOrigin(0.5);

		const messageText = this.add.text(centerX, centerY + 20, message, {
			fontSize: 24,
			fontFamily: 'Arial',
			fill: '#ffffff',
			align: 'center',
			wordWrap: { width: width * 0.7 }
		}).setOrigin(0.5);

		// Bottone riprova (semplice rettangolo)
		const retryButton = this.add.rectangle(centerX, centerY + 100, 200, 50, 0x666666);
		retryButton.setStrokeStyle(2, 0xffffff);
		retryButton.setInteractive({ useHandCursor: true });

		const retryText = this.add.text(centerX, centerY + 100, 'RIPROVA', {
			fontSize: 24,
			fontFamily: 'Arial',
			fill: '#ffffff',
			align: 'center'
		}).setOrigin(0.5);

		retryButton.on('pointerdown', () => {
			window.location.reload();
		});
	}

	onLoadComplete() {
		console.log('onLoadComplete');
		this.ready = true;
	}

	//  ------------------------------------------------------------------------

	/**
	 *  Show the splash screen cover.
	 *
	 *  @private
	 */
	showCover() {
		this.add.image(this.sys.game.config.width / 2, this.sys.game.config.height / 2, 'logo').setOrigin(0.5);
	}

	/**
	 *  Show the progress bar and set up its animation effect.
	 *
	 *  @private
	 */
	showProgressBar() {
		//  Get the progress bar filler texture dimensions.
		const {width: w, height: h} = this.textures.get('progress-bar').get();

		//  Create a shape to use as a mask for our progress bar filler.
		const mask = this.add.graphics();

		//  Place the filler texture on the progress bar "hole" of the splash
		//  screen.
		const img = this.add
			.sprite(this.sys.game.config.width / 2 - 238, this.sys.game.config.height / 2 + 200, 'progress-bar')
			.setOrigin(0);

		//  Apply the mask and move the shape at the same coordinates of the
		//  filler texture.
		img.mask = new Phaser.Display.Masks.GeometryMask(this, mask);
		mask.setPosition(img.x, img.y);

		//  Given how many files have been loaded, paint the shape mask to reveal
		//  more of the filler, giving the progress bar its animation effect.
		this.load.on('progress', (v) => mask.fillRect(0, 0, Math.ceil(v * w), h));
	}
}
